const defaultOptions = [
  { name: "Material", values: ["Folheado a Ouro 18k", "Prata 925", "Aço Inoxidável"] },
  { name: "Comprimento", values: ["40 cm", "45 cm", "50 cm"] },
];

export interface ProductOptionGroup {
  name: string;
  values: string[];
}

export interface ProductDetail {
  id: number;
  rating: number;
  reviews: number;
  sku: string;
  extras: string[];
  options: ProductOptionGroup[];
  description: string;
  features: string[];
}

export const productDetails: ProductDetail[] = [
  {
    id: 1,
    rating: 4.9,
    reviews: 128,
    sku: "RT-COL-001",
    extras: [
      "https://readdy.ai/api/search-image?query=Close-up%20macro%20shot%20of%20a%20small%20delicate%20gold%20heart%20pendant%20necklace%20detail%2C%20soft%20warm%20cream%20background%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20refined%20minimal%20aesthetic&width=600&height=750&seq=colar-coracao-detalhe-01a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Gold%20heart%20pendant%20necklace%20flat%20lay%20on%20soft%20cream%20linen%20fabric%20top%20view%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20elegant%20aesthetic&width=600&height=750&seq=colar-coracao-detalhe-01b&orientation=portrait",
    ],
    options: defaultOptions,
    description:
      "O Colar Coração Minimal traduz delicadeza em poucos traços. Um pequeno coração em banho de ouro 18k repousa sobre uma corrente fina e luminosa, perfeito para usar sozinho ou sobreposto com outros colares. Uma peça atemporal que acompanha o seu dia a dia com elegância discreta.",
    features: [
      "Banho de ouro 18k com alta durabilidade",
      "Corrente ajustável com fecho reforçado",
      "Hipoalergênico e livre de níquel",
      "Acompanha embalagem exclusiva para presente",
    ],
  },
  {
    id: 2,
    rating: 4.8,
    reviews: 96,
    sku: "RT-COL-002",
    extras: [
      "https://readdy.ai/api/search-image?query=Close-up%20of%20layered%20double%20gold%20chain%20necklace%20texture%20and%20clasp%20detail%2C%20soft%20warm%20cream%20background%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-duplo-elegance-detalhe-02a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Two%20layered%20gold%20chain%20necklaces%20flat%20lay%20on%20cream%20linen%20top%20view%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20elegant%20aesthetic&width=600&height=750&seq=colar-duplo-elegance-detalhe-02b&orientation=portrait",
    ],
    options: defaultOptions,
    description:
      "O Colar Duplo Elegance entrega o efeito sobreposto sem esforço. Duas correntes de elos diferentes se encontram em uma única peça, criando profundidade e movimento no colo. O acabamento polido reflete a luz de forma sutil, valorizando qualquer decote.",
    features: [
      "Efeito sobreposto em peça única",
      "Dois comprimentos de corrente integrados",
      "Banho de ouro 18k de alto brilho",
      "Hipoalergênico e livre de níquel",
    ],
  },
  {
    id: 3,
    rating: 4.9,
    reviews: 74,
    sku: "RT-COL-003",
    extras: [
      "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20round%20engraved%20gold%20coin%20medal%20pendant%20necklace%2C%20soft%20warm%20cream%20background%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-medalha-detalhe-03a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Round%20gold%20medal%20coin%20pendant%20necklace%20flat%20lay%20on%20cream%20fabric%20top%20view%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20elegant%20aesthetic&width=600&height=750&seq=colar-medalha-detalhe-03b&orientation=portrait",
    ],
    options: defaultOptions,
    description:
      "Inspirado nas medalhas clássicas, este colar traz um disco dourado com acabamento martelado que captura a luz de forma única. Uma peça de presença marcante, mas ainda assim versátil o suficiente para o uso diário.",
    features: [
      "Medalha com acabamento martelado artesanal",
      "Corrente reforçada de elos resistentes",
      "Banho de ouro 18k com verniz protetor",
      "Garantia de 1 ano contra descoloração",
    ],
  },
  {
    id: 4,
    rating: 4.7,
    reviews: 58,
    sku: "RT-COL-004",
    extras: [
      "https://readdy.ai/api/search-image?query=Macro%20close-up%20of%20a%20single%20emerald%20green%20gemstone%20pendant%20with%20gold%20setting%20on%20a%20necklace%2C%20soft%20warm%20cream%20background%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-ponto-verde-detalhe-04a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Delicate%20gold%20necklace%20with%20green%20gemstone%20pendant%20flat%20lay%20on%20cream%20silk%20top%20view%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20elegant%20aesthetic&width=600&height=750&seq=colar-ponto-verde-detalhe-04b&orientation=portrait",
    ],
    options: defaultOptions,
    description:
      "Um ponto de cor que muda tudo. O Colar Ponto de Luz Verde traz uma pedra facetada em tom esmeralda, montada em um delicado engaste dourado. Perfeito para quem gosta de discrição com um toque de personalidade.",
    features: [
      "Pedra facetada de cor esmeralda",
      "Engaste dourado com quatro garras",
      "Corrente delicada de 1 mm",
      "Hipoalergênico e livre de níquel",
    ],
  },
  {
    id: 5,
    rating: 4.9,
    reviews: 142,
    sku: "RT-COL-005",
    extras: [
      "https://readdy.ai/api/search-image?query=Macro%20close-up%20of%20a%20single%20lustrous%20white%20pearl%20pendant%20on%20a%20gold%20necklace%2C%20soft%20warm%20cream%20background%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-perola-moderna-detalhe-05a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Gold%20necklace%20with%20white%20pearl%20pendant%20flat%20lay%20on%20cream%20fabric%20top%20view%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20elegant%20aesthetic&width=600&height=750&seq=colar-perola-moderna-detalhe-05b&orientation=portrait",
    ],
    options: defaultOptions,
    description:
      "Clássico reinventado. O Colar Pérola Moderna une a sofisticação da pérola a um design contemporâneo e minimalista. A pérola de água doce, com brilho suave e natural, se destaca em qualquer produção do dia à noite.",
    features: [
      "Pérola de água doce selecionada",
      "Formato contemporâneo e minimalista",
      "Banho de ouro 18k de alto brilho",
      "Acompanha embalagem exclusiva para presente",
    ],
  },
  {
    id: 6,
    rating: 5,
    reviews: 210,
    sku: "RT-COL-006",
    extras: [
      "https://readdy.ai/api/search-image?query=Macro%20close-up%20of%20a%20polished%20gold%20initial%20letter%20A%20pendant%20on%20a%20necklace%2C%20soft%20warm%20cream%20background%2C%20personalized%20jewelry%20product%20photography%2C%20soft%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-inicial-detalhe-06a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Gold%20initial%20letter%20pendant%20necklace%20flat%20lay%20on%20cream%20silk%20top%20view%2C%20personalized%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20elegant%20aesthetic&width=600&height=750&seq=colar-inicial-detalhe-06b&orientation=portrait",
    ],
    options: defaultOptions,
    description:
      "Sua história, sua inicial. O Colar Inicial Personalizada traz a letra de quem você ama (ou de quem você é) em traço fino e elegante. Escolha a inicial e transforme a peça em algo só seu.",
    features: [
      "Personalização com a inicial de sua escolha",
      "Traço fino com acabamento polido",
      "Banho de ouro 18k com verniz protetor",
      "Ideal para presentear",
    ],
  },
  {
    id: 7,
    rating: 4.8,
    reviews: 87,
    sku: "RT-COL-007",
    extras: [
      "https://readdy.ai/api/search-image?query=Macro%20close-up%20of%20a%20riviera%20tennis%20necklace%20with%20sparkling%20clear%20stones%20in%20a%20row%2C%20soft%20warm%20cream%20background%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-riviera-detalhe-07a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Sparkling%20zirconia%20riviera%20necklace%20flat%20lay%20on%20cream%20velvet%20top%20view%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20elegant%20aesthetic&width=600&height=750&seq=colar-riviera-detalhe-07b&orientation=portrait",
    ],
    options: defaultOptions,
    description:
      "Brilho de festa, conforto de todo dia. O Colar Riviera Zircônia traz uma fileira contínua de pedras lapidadas que refletem a luz como diamantes. Uma peça que rouba a cena em qualquer ocasião especial.",
    features: [
      "Fileira contínua de zircônias lapidadas",
      "Engaste trabalhado que destaca o brilho",
      "Fecho seguro com trava de segurança",
      "Banho de ouro 18k com verniz protetor",
    ],
  },
  {
    id: 8,
    rating: 4.7,
    reviews: 63,
    sku: "RT-COL-008",
    extras: [
      "https://readdy.ai/api/search-image?query=Macro%20close-up%20of%20a%20four%20leaf%20clover%20gold%20charm%20pendant%20necklace%2C%20soft%20warm%20cream%20background%2C%20lucky%20charm%20jewelry%20product%20photography%2C%20soft%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-trevo-detalhe-08a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Four%20leaf%20clover%20pendant%20necklace%20flat%20lay%20on%20cream%20linen%20top%20view%2C%20lucky%20charm%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20elegant%20aesthetic&width=600&height=750&seq=colar-trevo-detalhe-08b&orientation=portrait",
    ],
    options: defaultOptions,
    description:
      "Um amuleto de sorte para levar perto do coração. O Colar Trevo da Sorte traz o trevo de quatro folhas em traço delicado e acabamento brilhante — um lembrete diário de boas energias.",
    features: [
      "Trevo de quatro folhas em traço delicado",
      "Acabamento polido de alto brilho",
      "Corrente leve e confortável",
      "Hipoalergênico e livre de níquel",
    ],
  },
  {
    id: 9,
    rating: 4.9,
    reviews: 118,
    sku: "RT-COL-009",
    extras: [
      "https://readdy.ai/api/search-image?query=Macro%20close-up%20of%20a%20gold%20necklace%20densely%20paved%20with%20shimmering%20zirconia%20crystals%20detail%2C%20soft%20warm%20cream%20background%2C%20luxury%20jewelry%20photography%2C%20soft%20lighting%2C%20glamorous%20aesthetic&width=600&height=750&seq=colar-cravejado-detalhe-09a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Luxurious%20zirconia%20paved%20gold%20necklace%20flat%20lay%20on%20cream%20velvet%20top%20view%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20glamorous%20elegant%20aesthetic&width=600&height=750&seq=colar-cravejado-detalhe-09b&orientation=portrait",
    ],
    options: defaultOptions,
    description:
      "Para os dias que pedem muito brilho. O Colar Cravejado Luxo é inteiramente pavimentado com zircônias de lapidação impecável, criando um efeito de luz contínua ao redor do colo. A peça de destaque de qualquer produção.",
    features: [
      "Pavimentação total em zircônias",
      "Lapidação impecável de alto brilho",
      "Estrutura em latão com banho triplo",
      "Acompanha embalagem exclusiva para presente",
    ],
  },
  {
    id: 10,
    rating: 4.8,
    reviews: 71,
    sku: "RT-COL-010",
    extras: [
      "https://readdy.ai/api/search-image?query=Macro%20close-up%20of%20small%20dangling%20gold%20pearl%20drop%20charms%20on%20a%20delicate%20necklace%2C%20soft%20warm%20cream%20background%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-gotas-detalhe-10a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Delicate%20necklace%20with%20pearl%20drop%20charms%20flat%20lay%20on%20cream%20fabric%20top%20view%2C%20luxury%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20elegant%20aesthetic&width=600&height=750&seq=colar-gotas-detalhe-10b&orientation=portrait",
    ],
    options: defaultOptions,
    description:
      "Movimento e leveza em cada detalhe. O Colar Gotas Delicadas traz pequenas pérolas pendentes que balançam suavemente a cada movimento, criando um efeito romântico e refinado.",
    features: [
      "Pérolas pendentes com movimento natural",
      "Distribuição uniforme das gotas",
      "Corrente leve e confortável",
      "Hipoalergênico e livre de níquel",
    ],
  },
  {
    id: 11,
    rating: 4.7,
    reviews: 54,
    sku: "RT-COL-011",
    extras: [
      "https://readdy.ai/api/search-image?query=Macro%20close-up%20of%20two%20interlocking%20gold%20circle%20rings%20pendant%20on%20a%20necklace%2C%20soft%20warm%20cream%20background%2C%20modern%20jewelry%20product%20photography%2C%20soft%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-circulos-detalhe-11a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Interlocking%20gold%20circles%20pendant%20necklace%20flat%20lay%20on%20cream%20silk%20top%20view%2C%20modern%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimal%20elegant%20aesthetic&width=600&height=750&seq=colar-circulos-detalhe-11b&orientation=portrait",
    ],
    options: defaultOptions,
    description:
      "Formas geométricas que se encontram. O Colar Duplo Círculos traz dois anéis dourados entrelaçados, símbolo de conexão e continuidade. Design contemporâneo com acabamento impecável.",
    features: [
      "Dois círculos entrelaçados",
      "Design geométrico contemporâneo",
      "Acabamento polido de alto brilho",
      "Banho de ouro 18k com verniz protetor",
    ],
  },
  {
    id: 12,
    rating: 4.9,
    reviews: 93,
    sku: "RT-COL-012",
    extras: [
      "https://readdy.ai/api/search-image?query=Macro%20close-up%20of%20a%20natural%20green%20gemstone%20teardrop%20pendant%20with%20gold%20setting%20on%20a%20necklace%2C%20soft%20warm%20cream%20background%2C%20bohemian%20luxury%20jewelry%20product%20photography%2C%20soft%20lighting%2C%20minimal%20aesthetic&width=600&height=750&seq=colar-pedra-natural-detalhe-12a&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Gold%20necklace%20with%20green%20natural%20stone%20teardrop%20pendant%20flat%20lay%20on%20cream%20linen%20top%20view%2C%20bohemian%20luxury%20jewelry%20product%20photography%2C%20soft%20natural%20lighting%2C%20natural%20elegant%20aesthetic&width=600&height=750&seq=colar-pedra-natural-detalhe-12b&orientation=portrait",
    ],
    options: defaultOptions,
    description:
      "Cada pedra é única, e a sua também será. O Colar Com Pedra Natural traz uma gema em formato gota com nuances próprias, montada em engaste dourado. Uma peça orgânica que valoriza a beleza natural.",
    features: [
      "Pedra natural com nuances exclusivas",
      "Formato gota com engaste dourado",
      "Peça artesanal com acabamento manual",
      "Acompanha embalagem exclusiva para presente",
    ],
  },
];